/* @flow */

import {useQuery} from '@apollo/react-hooks';

import type {
    GetContactsSearchResults as GetContactsSearchResultsQuery,
    GetContactsSearchResultsVariables as GetContactsSearchResultsQueryVariables,
} from 'nutshell-graphql-types';

import {makeDataSafe} from 'nutshell-core/utils/graphql-errors';

import GET_CONTACTS_SEARCH_RESULTS from '../queries/get-contacts-search-results.graphql';

export const useGetContacts = (
    query: ?string
): ({
    isLoading: boolean,
    contacts: Object[],
    refetch: () => Promise<*>,
    fetchMore: (searchTerm: ?string) => Promise<*>,
}) => {
    const {data, loading, refetch, fetchMore} = useQuery<
        GetContactsSearchResultsQuery,
        GetContactsSearchResultsQueryVariables
    >(GET_CONTACTS_SEARCH_RESULTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            query,
        },
        notifyOnNetworkStatusChange: true,
    });

    const {search} = makeDataSafe(data);
    const quickResults = search ? search.quickResults : null;

    const contactResults = quickResults ? quickResults.contactResults : [];

    return {
        contacts: contactResults,
        isLoading: loading,
        refetch,
        fetchMore: (searchTerm: ?string) => {
            // $FlowIgnore
            return fetchMore({
                query: GET_CONTACTS_SEARCH_RESULTS,
                variables: {
                    query: searchTerm,
                },
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return {
                        search: {
                            __typename: 'SearchResultItemConnection',
                            ...fetchMoreResult.search,
                        },
                    };
                },
            });
        },
    };
};
